import { FC } from 'react';
import PopUpContainer from 'src/components/common/modal/PopUp';
import './styles.scss';

interface IProps {
  externalUrl: string;
  close: () => void;
}
const PromotionModal: FC<IProps> = ({ externalUrl, close }) => {
  return (
    <PopUpContainer isOpen handleClose={close} hasOverlay type="fullSize">
      <iframe src={externalUrl} className="promo_iframe" />
    </PopUpContainer>
  );
};

export default PromotionModal;
